import { FormDataModel } from '@/model/FormModel'
import { baseForm } from './baseForm'
// import { TableFieldModel } from '@/model/TableList'
// import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils/index'

export const FromFieldData: FormDataModel[] = [
  {
    title: '市场费',
    type: 2,
    labelClass: 'yellow',
    labelName: '工',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'list',
        fieldName: '渲染列表',
        config: {},
        id: 0,
        list: baseForm
      }
    ]
  }
]

export const MarketFeeFieldData: FormDataModel[] = [
  {
    title: '市场费',
    type: 2,
    labelClass: 'yellow',
    labelName: '市',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'list',
        fieldName: '渲染列表',
        config: {},
        id: 0,
        list: baseForm
      }
    ]
  }
]
